import "./SurveyListFilters.scss";
import SearchInput from "../../../components/SearchInput/SearchInput";
import SelectInput from "../../../components/SelectInput/SelectInput";
import Buttons from "../../../components/Buttons/Buttons";
import { PlusIcon } from "../../../assets/icons-components/Icons";
import { SURVEY_STATUS_FILTER_OPTIONS } from "../../../utils/surveysConstants";
import useSurveysList from "./useSurveysList";
import SurveysListRows from "./SurveysListRows";
import SurveyAssignModal from "./SurveyAssignModal";
import SurveyViewModal from "./SurveyViewModal";
import ConfirmDialog from "../../../components/ConfirmDialog/ConfirmDialog";

export default function SurveysListPage() {
  const {
    rows,
    page,
    rowsPerPage,
    searchQuery,
    statusFilter,
    totalRows,
    isLoading,
    fetchError,
    assignSurvey,
    viewSurvey,
    archiveDialog,
    handleSearchChange,
    handleStatusFilterChange,
    handleChangePage,
    handleChangeRowsPerPage,
    handleCreate,
    handleEdit,
    handleViewResults,
    handleViewClick,
    closeViewModal,
    handlePublish,
    handleArchiveClick,
    confirmArchive,
    handleAssignClick,
    closeAssignModal,
    handleAssigned,
    handleExportJSON,
    retryFetch,
  } = useSurveysList();

  return (
    <div className="surveys-list">
            <div className="survey-filters-bar">
        <div className="survey-filters-bar_fields">
          <div className="survey-filters-bar_fields_search">
            <SearchInput
              className="mainadd_header2_center_searchbar"
              name="searchQuery"
              placeholder="Search by survey title"
              value={searchQuery}
              onChange={handleSearchChange}
            />
          </div>
          <div className="survey-filters-bar_fields_status">
            <SelectInput
              name="statusFilter"
              value={statusFilter}
              onChange={handleStatusFilterChange}
              options={SURVEY_STATUS_FILTER_OPTIONS}
              placeholder="All Statuses"
              clearable
            />
          </div>
        </div>
        <div className="survey-filters-bar_actions">
          <Buttons
            text="Create Survey"
            type="button"
            variant="primary"
            fullWidth={false}
            style={{ height: 40 }}
            onClick={handleCreate}
            icon={<PlusIcon />}
          />
        </div>
      </div>

      <SurveysListRows
        rows={rows}
        page={page}
        rowsPerPage={rowsPerPage}
        totalRows={totalRows}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
        isLoading={isLoading}
        fetchError={fetchError}
        onRetry={retryFetch}
        onEdit={handleEdit}
        onView={handleViewClick}
        onViewResults={handleViewResults}
        onPublish={handlePublish}
        onArchive={handleArchiveClick}
        onAssign={handleAssignClick}
        onExportJSON={handleExportJSON}
      />

      {viewSurvey && (
        <SurveyViewModal
          survey={viewSurvey}
          onClose={closeViewModal}
          onAssign={handleAssignClick}
        />
      )}

      {assignSurvey && (
        <SurveyAssignModal
          survey={assignSurvey}
          onClose={closeAssignModal}
          onAssigned={handleAssigned}
        />
      )}

      {archiveDialog.open && (
        <ConfirmDialog
          open={archiveDialog.open}
          onClose={archiveDialog.closeDialog}
          title="Archive Survey"
          severity="warning"
          confirmText="ARCHIVE"
          content={
            <span>
              Are you sure you want to archive <strong>{archiveDialog.target?.title}</strong>? It will no longer be assignable to patients.
            </span>
          }
          buttonText="Yes, Archive"
          additionalButtonText="Cancel"
          onButtonClick={confirmArchive}
          onAdditionalButtonClick={archiveDialog.closeDialog}
        />
      )}
    </div>
  );
}
